import { render } from "./CalendarTabView1.vue?vue&type=template&id=bb51684e"
import script from "./CalendarTabView1.vue?vue&type=script&lang=js"
export * from "./CalendarTabView1.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__